import {request} from "@/api/request.js";
const Detail={
    getDetailIntroduction(asmid){
        return request.get("/detail/Introduction",{asmid:asmid})
    },
    getAssociatedGenes(snv,cpgPos){
        return request.get("/detail/associatedGenes",{snv:snv,cpgPos:cpgPos})
    },
    getCisAndTFbinding(snv,cpgPos,chr){
        return request.get(
            "/detail/cis_tfbinding",
            {
                snv:snv,
                cpgPos:cpgPos,
                chr:chr
            })
    },
    getDetailGWAS(snv){
        return request.get("/detail/gwas",{snv:snv})
    },
}
export default Detail;
